"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DateInputPolyfill_1 = require("../../components/DateInputPolyfill");
DateInputPolyfill_1.DateInputPolyfill.each('input[type=date]');
